import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";

import {
  childClassEnrollmentsCrudConfig,
  classEnrollmentsCrudConfig
} from "../consts";

export const {
  fetchAllActionFactory: fetchAllClassesEnrollmentsActionFactory,
  fetchActionFactory: fetchClassEnrollmentActionFactory,
  createActionFactory: createClassEnrollmentActionFactory,
  deleteActionFactory: deleteClassEnrollmentActionFactory
} = makeCrudStateActionFactories(classEnrollmentsCrudConfig);

export const { fetchActionFactory: fetchChildClassEnrollmentsActionFactory } =
  makeCrudStateActionFactories(childClassEnrollmentsCrudConfig);
